import { getRegionSelectionEnabledStatus } from '@store/config';
import { useAppSelector } from '@store/hooks';

export function useRegionSelectorFeatureToggle() {
  const regionSelector = useAppSelector(getRegionSelectionEnabledStatus());

  return regionSelector;
}
